<template>
  <section class="app-modal__section payment-plan-pay-modal__section--amount-compact">
    <section class="payment-plan-pay-modal__amount-box">
      <header class="payment-plan-pay-modal__amount-box-head">
        <div>
          <h5>{{ text.payModal.amountBox.title }}</h5>
          <p>{{ text.payModal.amountBox.subtitle }}</p>
        </div>

        <AppCurrencyControl
          v-model="currencyModel"
          :exchange-rate="exchangeRate"
          @update:exchange-rate="$emit('update:exchangeRate', $event)"
        />
      </header>

      <div class="app-modal__grid two-columns">
        <label class="app-modal-field">
          <span>{{ text.payModal.amountBox.fields.amount }}</span>
          <AppMoneyInput
            v-model="amountModel"
            output-mode="number"
            :decimal-places="2"
            :minimum-value="0"
            :currency="currencyCode"
          />
          <small v-if="amountErrorMessage" class="invalid-feedback d-block">
            {{ amountErrorMessage }}
          </small>
          <small v-else-if="amountWarningMessage" class="payment-plan-pay-modal__warning">
            {{ amountWarningMessage }}
          </small>
        </label>

        <label class="app-modal-field">
          <span>{{ text.payModal.amountBox.fields.paymentDate }}</span>
          <VueDatePicker
            v-model="paymentDateValueModel"
            class="app-modal-datepicker"
            menu-class-name="app-modal-datepicker-menu"
            :placeholder="text.payModal.amountBox.placeholders.paymentDate"
            :enable-time-picker="false"
            auto-apply
            locale="es-MX"
            format="dd/MM/yyyy"
            hide-input-icon
            :show-now-button="true"
            :now-button-label="text.payModal.amountBox.nowButton"
          />
        </label>
      </div>

      <div class="payment-plan-pay-modal__amount-box-summary">
        <div>
          <span>{{ resolvedReferenceAmountLabel }}</span>
          <strong>{{ formatAmountWithCurrency(planAmount, currencyCode) }}</strong>
        </div>
        <div>
          <span>{{ text.payModal.amountBox.summary.payAmount }}</span>
          <strong>{{ formatAmountWithCurrency(amount, currencyCode) }}</strong>
        </div>
        <div>
          <span>{{ text.payModal.amountBox.summary.pendingBalance }}</span>
          <strong>{{ formatAmountWithCurrency(remainingAmount, currencyCode) }}</strong>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import AppMoneyInput from '@/components/common/AppMoneyInput.vue';
import AppCurrencyControl from '@/components/common/AppCurrencyControl.vue';
import { formatAmountWithCurrency } from '@/utils/numberFormat';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'PayModalSectionAmounts',
  components: {
    VueDatePicker,
    AppMoneyInput,
    AppCurrencyControl,
  },
  emits: ['update:currencyCode', 'update:exchangeRate', 'update:amount', 'update:paymentDateModel'],
  props: {
    text: {
      type: Object,
      required: true,
    },
    currencyCode: {
      type: String,
      default: 'MXN',
    },
    exchangeRate: {
      type: Number,
      default: 1,
    },
    amount: {
      type: Number,
      default: 0,
    },
    paymentDateModel: {
      type: [Date, String, Object],
      default: null,
    },
    planAmount: {
      type: Number,
      default: 0,
    },
    referenceAmountLabel: {
      type: String,
      default: '',
    },
    remainingAmount: {
      type: Number,
      default: 0,
    },
    amountErrorMessage: {
      type: String,
      default: '',
    },
    amountWarningMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    currencyModel: {
      get() {
        return this.currencyCode;
      },
      set(value) {
        this.$emit('update:currencyCode', String(value || '').trim().toUpperCase() || 'MXN');
      },
    },
    amountModel: {
      get() {
        return Number(this.amount || 0) || 0;
      },
      set(value) {
        this.$emit('update:amount', Number(value || 0) || 0);
      },
    },
    paymentDateValueModel: {
      get() {
        return this.paymentDateModel;
      },
      set(value) {
        this.$emit('update:paymentDateModel', value || null);
      },
    },
    resolvedReferenceAmountLabel() {
      const explicit = String(this.referenceAmountLabel || '').trim();
      if (explicit !== '') {
        return explicit;
      }

      return String(this.text?.payModal?.amountBox?.summary?.planAmount || '').trim();
    },
  },
  methods: {
    formatAmountWithCurrency,
  },
};
</script>
